export const STAFF = {
  inviteStaffMember: "vendor/invitestaff",
  invitedStaff: "vendor/staffmember",
  staffById: "vendor/staffmemberbyid?",
  deleteStaff: "vendor/deletestaff?",
};
